import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'agents-info-dialog',
  templateUrl: 'agents-Info-dialog.html',
})
export class AgentsInfoDialog {
  title: string;
  htmlData: string;
  constructor(
    public dialogRef: MatDialogRef<AgentsInfoDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; html: string },
  ) {
    this.title = data.title;
    this.htmlData = data.html;
  }

  ngOnInit() {}

  close(): void {
    this.dialogRef.close();
  }
}
